export const SEND_MESSAGE = 'SEND_MESSAGE';
export const ADD_POST = 'ADD_POST';
export const FOLLOW = 'FOLLOW';
export const UNFOLLOW = 'UNFOLLOW';
export const SET_USERS = 'SET_USERS';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_DATA = 'SET_USER_DATA';
export const INITIALIZED_SUCCESS = 'INITIALIZED_SUCCESS';
export const SET_USER_STATUS = 'SET_USER_STATUS';
export const SET_USER_PHOTOS_SUCCESS = 'SET_USER_PHOTOS_SUCCESS';
export const GET_CAPTCHA_URL_SUCCESS = 'GET_CAPTCHA_URL_SUCCESS';
export const ADD_FOLLOWED_USER_TO_DIALOGS = 'ADD_FOLLOWED_USER_TO_DIALOGS';
export const DELETE_UNFOLLOWED_USER_FROM_DIALOGS =
  'DELETE_UNFOLLOWED_USER_FROM_DIALOGS';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const DRAWER_TOGGLE = 'DRAWER_TOGGLE';
